module.exports = __webpack_public_path__ + "static/media/p_21_0.bb7304ed.png";